import { Component } from '@angular/core'

const setup = `pnpm run setup`
const start = `pnpm start docs`
const startDev = `pnpm start:dev docs`

@Component({
  selector: 'se-po-shared-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  standalone: false,
})
export class OverviewComponent {
  public code = {
    setup,
    start,
    startDev
  }

}
